import React from 'react';
import { Body, Box } from '@hover/blueprint';

interface ISearchResultHeaderProps {
  searchKeyword: string;
}

const SearchResultHeader: React.FC<ISearchResultHeaderProps> = ({
  searchKeyword,
}) => (
  <Box mb={700}>
    <Body size={500} fontWeight={300} display="flex">
      Search results for :&nbsp;
      <Body fontWeight={600}>“{searchKeyword}”</Body>
    </Body>
  </Box>
);

export default SearchResultHeader;
